/**
 * Gets object from FormData interface
 * @param fd{FormData=} - source FormData instance
 * @return {Object}
 * @example
 */
// eslint-disable-next-line no-undef
const getObjFromFormData = (fd = new FormData()) => {
  const entries = [...fd].map(([name, value]) => {
    const values = fd.getAll(name)
    return [name, values.length > 1 ? values : value]
  })
  return Object.fromEntries(entries)
}
export { getObjFromFormData }
